import { API_CALL } from 'actions/actionConstants'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'
import { GoogleLoginData } from 'actions/AuthActions'
import { AppAction } from 'actions/types/ActionTypes'
import { requestPostGoogleLinkPersonalAccount } from 'businessTraveller/api/requestPostGoogleLinkPersonalAccount'
import * as authService from 'api/auth'
import { LUXURY_ESCAPES } from 'constants/brands'

export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_GOOGLE_LINK_ACCOUNT_CALLBACK_SOURCE = 'business-traveller-business-signup-link-account'
export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_GOOGLE_LINK_ACCOUNT_SUCCESS_EVENT = 'business-traveller-business-signup-google-link-account-success'
export const BUSINESS_TRAVELLER_BUSINESS_SIGNUP_GOOGLE_LINK_ACCOUNT_FAILURE_EVENT = 'business-traveller-business-signup-google-link-account-failure'

export function loginGoogle(data: GoogleLoginData): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const transformedData = {
      ...data,
      country_code: state.geo.currentRegionCode,
      signup_domain: window.location.hostname,
    }

    dispatch({
      type: API_CALL,
      api: BUSINESS_TRAVELLER_API_ACTIONS.USER_LINK_PERSONAL_ACCOUNT,
      request: () => requestPostGoogleLinkPersonalAccount(transformedData).then(data => {
        window.dispatchEvent(new CustomEvent('google-login-success', {
          detail: { email: transformedData.email }
        }))
        return data
      }),
      source: 'email',
    })
  }
}

export function loginGoogleForBusinessSignup(data: GoogleLoginData): AppAction {
  return async(dispatch, getState) => {
    const state = getState()

    try {
      const response = await authService.loginGoogle(
        data,
        state.geo.currentRegionCode,
        false,
        {
          brand: LUXURY_ESCAPES,
          includeCredentials: false,
        },
      )

      window.dispatchEvent(new CustomEvent(BUSINESS_TRAVELLER_BUSINESS_SIGNUP_GOOGLE_LINK_ACCOUNT_SUCCESS_EVENT, {
        detail: { accessToken: response.accessToken, account: response.account },
      }))
    } catch(error) {
      window.dispatchEvent(new CustomEvent(BUSINESS_TRAVELLER_BUSINESS_SIGNUP_GOOGLE_LINK_ACCOUNT_FAILURE_EVENT, {
        detail: { error },
      }))
    }
  }
}
